import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { Observable } from 'rxjs';
import { DocumentoObras } from '../models/documento-obras.model';

@Injectable({
  providedIn: 'root',
})
export class DocumentoObrasService extends BaseService<DocumentoObras> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/qrobras/documentos';
  }

  public updateDocumento(obj, id: number): Observable<any> {
    return this.http.post<DocumentoObras>(this.baseUrl + '/' + id, obj);
  }

  public createDocumento(obj): Observable<DocumentoObras> {
    return this.http.post<DocumentoObras>(this.baseUrl, obj);
  }

  public getListFilters(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-filters', { headers: this.headers });
  }

  public download(id: number): Observable<HttpResponse<Blob>> {
    return this.http.get(this.baseUrl + "/download/" + id, {
      headers: this.headers,
      responseType: 'blob',
      observe: 'response'
    })
  }

  extractFilename(contentDispositionHeader: string): string | null {
    const matches = contentDispositionHeader.match(/filename\*=(?:UTF-8['']?)?([^;\r\n]*)/i);
    if (matches && matches.length > 1) {
      let encodedFilename = matches[1].trim();
      return decodeURIComponent(encodedFilename);
    }
    return null;
  }
}
